import type { ObjectMetadata } from '@olytic/foundation';

import { formatBytes } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { createdByField, lastModifiedByField, linkedRecordColumns, listColumnsOf, related, type Row, schemaRecord, show, text } from './kit';

const def = OBJECT_DEFS.documents;

/**
 * Its fields come from the database (the server's SCHEMA_OBJECTS), shown by
 * their type, the Owner linked to the person; any column not placed below
 * appears in Other Fields (MOTHER-306). The file's contents and its extracted
 * text are no fields: the server never reads them for the page. File Type
 * shows as written ("application/pdf"), Size in bytes, as before.
 */
const field = schemaRecord('documents');

const details = [
  field('name', 'Document Name'),
  field('mime_type', 'File Type', { format: text }),
  field('byte_size', 'Size', { format: show(formatBytes) }),
  field('uploaded_at', 'Uploaded'),
  field('owner_name', 'Owner'),
  field('source', 'Source'),
  field('description', 'Description', { wide: true }),
  field('storage_path', 'Storage Path'),
  field('source_id', 'Source ID'),
  field('text_extracted_at', 'Text Extracted'),
  field('created_at', 'Created'),
  field('updated_at', 'Last Modified'),
  createdByField(),
  lastModifiedByField(),
];

/** A document: a file attached to records. Rationale: documents.md. */
export const documents: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Document',
  plural: def.label,
  icon: def.icon,
  listColumns: listColumnsOf(def, details),
  details,
  sections: [
    { key: 'identity', fields: ['name', 'mime_type', 'byte_size', 'uploaded_at', 'owner_name', 'source', 'description'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name', 'storage_path', 'source_id', 'text_extracted_at'] },
  ],
  related: [related('links', 'Linked to', undefined, linkedRecordColumns())],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'description'],
};
